import { IPagination } from '@/types/general.type';
import { ApiResponse, axiosInstance } from '@/lib/axios';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { QueryConfig } from '@/lib/react-query';
import { TFetchParams } from '@/types/fetch.type';
import { filterEmptyValues } from '@/utils/object';
import { TTicketingUserInvitation } from '../types/ticketing-user.type';

export type TGetListTicketingUserInvitationResponse = ApiResponse<IPagination<TTicketingUserInvitation>>;
export type TGetListTicketingUserInvitationParams = TFetchParams & {
  roleId?: string;
};

export const getListTicketingUserInvitation = async (
  params: TGetListTicketingUserInvitationParams
): Promise<TGetListTicketingUserInvitationResponse> => {
  const url = `/invitation-ticketing`;

  const filteredParams = filterEmptyValues(params);

  return axiosInstance.get(url, { params: filteredParams });
};

export const GET_LIST_TICKETING_USER_INVITATION_QUERY_KEY = 'get-list-ticketing-user-invitation';

export const getListTicketingUserInvitationQueryOptions = (params: TGetListTicketingUserInvitationParams) => {
  return queryOptions({
    queryKey: [
      GET_LIST_TICKETING_USER_INVITATION_QUERY_KEY,
      {
        roleId: params?.roleId,
        search: params?.search,
        page: params?.page,
        limit: params?.limit,
        sortDir: params?.sortDir,
        sortBy: params?.sortBy,
      },
    ],
    queryFn: () => getListTicketingUserInvitation(params),
  });
};

type UseListTicketingUserInvitationQueryQueryOptions = {
  params: TGetListTicketingUserInvitationParams;
  queryConfig?: QueryConfig<typeof getListTicketingUserInvitationQueryOptions>;
};

export const useListTicketingUserInvitationQuery = ({
  queryConfig,
  params,
}: UseListTicketingUserInvitationQueryQueryOptions) => {
  return useQuery({
    ...getListTicketingUserInvitationQueryOptions(params),
    ...queryConfig,
  });
};
